import { useLocation } from "react-router-dom";
import Filarial from "../include/filarial";
import Layout from "../include/layout";
import InscriptionsService from "./InscriptionsService";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Button, Form, Modal } from "react-bootstrap";

export default function DetailsInscrit() {
    const activeLink = "Détails inscriptions"
    const token = useSelector(state => state.auth.token)
    const [detailsInscrit, setDetailsInscrit] = useState({})
    const [detailsApprenant, setDetailsApprenant] = useState({})
    const location = useLocation()
    const [showModalDossierFinancier, setShowModalDossierFinancier] = useState(false)
    const handleClose = () => setShowModalDossierFinancier(false);
    //const handleShow = () => setShowModalDossierFinancier(true);

    const getInscription = async()=>{
        await InscriptionsService.show(location.state.id, token).then(res => {
            const responseInscrit=res.data.data.classeoption
            setDetailsApprenant({
                montantScolarite:responseInscrit.montantClasseOption
            })
            //console.log('inscrit',responseInscrit)
        }).catch(error => {
            console.log(error)
        })
    }


    const getInscrit = async () => {
        await InscriptionsService.getDetailsInscrit(location.state.id, token).then(res => {
            //console.log('get_inscrit',res.data.data.inscription.personnes.nomPersonne)
            const responseData = res.data.data.inscription;
            setDetailsInscrit({
                numeromatriculePersonne: responseData.personnes.numeromatriculePersonne,
                nomPersonne: responseData.personnes.nomPersonne,
                prenomsPersonne: responseData.personnes.prenomsPersonne,
                ddn: responseData.personnes.ddn,
                lieuNaissance: responseData.personnes.lieuNaissance,
                nationnalite: responseData.personnes.pays.nationalitePays,
                libelleSexe: responseData.personnes.sexes.libelleSexe,
                libelleStatutapprenant: responseData.statutsapprenants.libelleStatutapprenant,
                updatedAt: responseData.updatedAt,
                nompereInscription: responseData.nompereInscription,
                nommereInscription: responseData.nommereInscription,
                contacts: responseData.contactprincipalInscription + ' / ' + responseData.contactsecondaireInscription,
                emailInscription: responseData.emailInscription,
                libelleClasse: responseData.classes.libelleClasse,
                personneId: responseData.personnes.id,
            })

            //getDetailsApprenant(res.data.data.personnes.id)
            //console.log('details',detailsInscrit) //montantInscription
        }).catch(error => {
            console.log(error)
        })
    }

    //Get details by personne_id
    /*const getDetailsApprenant = async (id) => {
        await InscriptionsService.getDetailsApprenant(id, token).then(res => {
            //get details paiement
            console.log('detail_inscrit',res.data.data)
        }).catch(error => {
            console.log(error)
        })
    }*/

    const handleDossier = async (id) => {
        setShowModalDossierFinancier(true)
    }


    useEffect(() => {
        getInscrit()
        getInscription() 
    }, [])

    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                <div className="row mb-4 mt-3">
                    {/* Bootstrap Validation */}
                    <div className="col-md">
                        <div className="card shadow-lg">
                            <h5 className="card-header bg-warning text-white text-center fw-bold" style={{ fontSize: "20px" }}> {`${detailsInscrit.nomPersonne} ${detailsInscrit.prenomsPersonne}`}</h5>
                            <div className="card-body">
                                <div className="col-md-12 pt-4">
                                    <span className="py-4 fw-bold">Imprimer fiche de l'apprenant&nbsp;&nbsp;</span> <span><button type="button" className="btn btn-danger btn-md"><i className="fas fa-file-pdf"></i>&nbsp;PDF</button></span> &nbsp;&nbsp;
                                    &nbsp;<span><button type="button" className="btn btn-success btn-md" onClick={() => handleDossier(detailsInscrit.personneId)}><i className="fas fa-file"></i>&nbsp;Dossier Financier</button></span>
                                    <span><button type="button" className="btn btn-info btn-md mx-3"><i className="fas fa-pencil"></i>&nbsp;Modifier les infos</button></span>
                                    <span><button type="button" className="btn btn-primary btn-md mx-3"><i className="fas fa-file-pdf"></i>&nbsp;Notes</button></span>
                                    <span><button type="button" className="btn btn-secondary btn-md"><i className="fas fa-file-pdf"></i>&nbsp;Bulletin</button></span>
                                </div>

                                <div className="col-md-12">
                                    <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2 mt-4">INFORMATIONS GENERALES</h5>
                                    {/* Responsive Datatable */}
                                    <div className="cardx shadow-lgx mt-3">
                                        <div className="card-datatable table-responsive px-0 pb-3 m-0 pl-0 pr-0">
                                            <table className="dt-responsive table border-top data-table table-hover table-borderedx table-striped w-100 mt-0" >
                                                <thead className="theme-bg-blue-white">
                                                    <tr className="">
                                                        <th className="theme-color-blue"><span className="theme-color-blue">N° mat</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Nom</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Prénoms</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Ddn</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Lieu Nais.</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Nationnalité</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Sexe</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Statut</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Date enreg.</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>{detailsInscrit.numeromatriculePersonne}</td>
                                                        <td>{detailsInscrit.nomPersonne}</td>
                                                        <td>{detailsInscrit.prenomsPersonne}</td>
                                                        <td>{dayjs(detailsInscrit.ddn).format("DD/MM/YYYY")}</td>
                                                        <td>{detailsInscrit.lieuNaissance}</td>
                                                        <td>{detailsInscrit.nationnalite}</td>
                                                        <td>{detailsInscrit.libelleSexe}</td>
                                                        <td><span className="fw-bold">{detailsInscrit.libelleStatutapprenant}</span></td>
                                                        <td>{dayjs(detailsInscrit.updatedAt).format("DD/MM/YYYY H:m:s")}</td>
                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {/*/ Responsive Datatable */}

                                </div>
                                <div className="row">
                                    {/**Informations  parents*/}
                                    <div className="col-md-6">
                                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2 mt-4">INFORMATIONS PARENTS / TUTEURS OU TUTRICES</h5>

                                        <div className="card shadow-lg mt-3 px-3 pt-4">
                                            <div className="card-datatable table-responsive px-0 pb-3 m-0 pl-0 pr-0">
                                                <table className="dt-responsive table border-top data-table table-hover table-borderedx table-striped w-100 mt-0" >
                                                    <thead className="theme-bg-blue-white">
                                                        <tr className="">
                                                            <th className="theme-color-blue"><span className="theme-color-blue">Nom du père</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Nom de la mère</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Contacts</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Email</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{detailsInscrit.nompereInscription}</td>
                                                            <td>{detailsInscrit.nommereInscription}</td>
                                                            <td>{detailsInscrit.contacts}</td>
                                                            <td>{detailsInscrit.emailInscription}</td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    {/**** Information sur l'inscription*/}
                                    <div className="col-md-6">
                                        <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2 mt-4">INFORMATIONS SUR L'INSCRIPTION</h5>

                                        <div className="card shadow-lg mt-3 px-3 pt-4">
                                            <div className="card-datatable table-responsive px-0 pb-3 m-0 pl-0 pr-0">
                                                <table className="dt-responsive table border-top data-table table-hover table-borderedx table-striped w-100 mt-0" >
                                                    <thead className="theme-bg-blue-white">
                                                        <tr className="">
                                                            <th className="theme-color-blue"><span className="theme-color-blue">Date Ins.</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Classe</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Montant Scolarité</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Montant Versé</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Reste</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{dayjs(detailsInscrit.updatedAt).format("DD/MM/YYYY H:m:s")}</td>
                                                            <td>{detailsInscrit.libelleClasse}</td>
                                                            <td>{detailsApprenant.montantScolarite}</td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2 mt-4">NOTES ET MOYENNES</h5>
                                    <div className="cardx shadow-lgx mt-3">
                                        <div className="card-datatable table-responsive px-0 pb-3 m-0 pl-0 pr-0">
                                            <table className="dt-responsive table border-top data-table table-hover table-borderedx table-striped w-100 mt-0" >
                                                <thead className="theme-bg-blue-white">
                                                    <tr className="">
                                                        <th className="theme-color-blue"><span className="theme-color-blue">Sem / Tri</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Type Note</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Matière</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Note</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Appréciation</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Enseignant</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Moy par mat.</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Moy sem.</span></th>
                                                        <th className="cell"><span className="theme-color-blue">Moy an.</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/***Modal pour afficher les details du dossier financier */}
                <>
                    <Modal
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={showModalDossierFinancier}
                        onHide={handleClose}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title className="text-white">
                                Dossier Financier
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <img
                                                className="me-2"
                                                src="/images/logo_gs_sans_fond.png"
                                                alt=""
                                                style={{ width: "24%", textAlign: "center" }}
                                            />
                                        </div>
                                        <div className="col-md-6"></div>
                                    </div>
                                </div>
                                <div className="col-md-12 text-center">
                                    <h5 className="theme-bg-blue-white theme-color-blue px-3 py-2">
                                    {detailsInscrit.nomPersonne} {detailsInscrit.prenomsPersonne}
                                    </h5>
                                </div>
                               {/**** Information sur l'inscription*/}
                               <div className="col-md-12">

                                        <div className="card shadow-lg mt-3 px-3 pt-4">
                                            <div className="card-datatable table-responsive px-0 pb-3 m-0 pl-0 pr-0">
                                                <table className="dt-responsive table border-top data-table table-hover table-borderedx table-striped w-100 mt-0" >
                                                    <thead className="theme-bg-blue-white">
                                                        <tr className="">
                                                            <th className="cell"><span className="theme-color-blue">Net à payer</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Montant payé</span></th>
                                                            <th className="cell"><span className="theme-color-blue">Reste</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>{dayjs(detailsInscrit.updatedAt).format("DD/MM/YYYY H:m:s")}</td>
                                                            <td>{detailsInscrit.libelleClasse}</td>
                                                            <td></td>
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                

                                <hr className="mr-0" />



                                <div className="col-md-8 mt-4 ">
                                    <div className="row"></div>
                                </div>
                            </Form>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    Fermer
                                </Button>
                                <Button
                                    variant="primary"
                                    type="button"
                                >
                                    Modifier
                                </Button>
                            </Modal.Footer>
                        </Modal.Body>
                    </Modal>
                </>
            </div>
        </Layout>
    )
}